import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const RecommendationForm = () => {
  const [UnitOfMeasures, setUnitOfMeasures] = useState([]);
  const [TenantOptions, setTenantOptions] = useState([]);
  const userData = JSON.parse(localStorage.getItem('@SoilAnalysis:user'));
  const userTenantID = userData.tenantID;

  const activeOptions = [
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' },
  ];

  const fields = [
    {
      label: 'Descrição',
      name: 'description',
      type: 'input',
    },
    {
      label: 'Empresa',
      name: 'tenantID',
      type: 'select',
      options: TenantOptions,
    },
    {
      label: 'Tipo',
      name: 'type',
      type: 'input',
    },
    {
      label: 'Unidade de medida',
      name: 'unitOfMeasureID',
      type: 'select',
      options: UnitOfMeasures,
    },
    {
      label: 'Ativo',
      name: 'isActive',
      type: 'select',
      options: activeOptions,
    },
  ];

  const loadData = async () => {
    Api.get('Tenant/getAllItems')
      .then(resultTenant => {
        if (resultTenant && resultTenant.data) {
          let options = resultTenant.data.response.map(item => ({
            value: item.tenantID,
            text: item.name,
          }));
          if (userTenantID == null) {
            options = [{ value: '', text: 'Selecione' }, ...options];
          } else {
            options = options.filter(opt => opt.value === userTenantID);
          }
          setTenantOptions(options);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });

    Api.get('UnitOfMeasure/getAllItems')
      .then(result => {
        if (result && result.data) {
          const options = result.data.response.map(item => ({
            value: item.unitOfMeasureID,
            text: item.description,
          }));

          setUnitOfMeasures(options);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return UnitOfMeasures.length > 0 && TenantOptions.length > 0 ? (
    <FormCrud
      formName={'recommendation'}
      title={'Itens de Recomendação'}
      fields={fields}
    />
  ) : (
    <></>
  );
};

export default RecommendationForm;
